import React from 'react';
import { Modal, Button, Form, Divider } from 'antd';
import { RangeDate } from 'components/datetime';
import useExport from '../hooks/useExport';

const ModalExport = ({ privilege, visible, hideModal }) => {
    const [form] = Form.useForm(); // Initialize form instance
    const {
        values,
        loading,
        handleSubmit,
    } = useExport(privilege, hideModal);


    return (
        <Modal
            maskClosable={false}
            title={"Export"}
            open={visible}
            onCancel={hideModal}
            width={300}
            footer={null}
        >
            <Form
                form={form}
                name="basic"
                autoComplete="off"
                layout="vertical"
                onFinish={handleSubmit}
                loading={loading}
                initialValues={values}
            >
                <Form.Item label="Periode" name="periode" rules={[{ required: true, message: 'Periode harus diisi' }]}>
                    <RangeDate />
                </Form.Item>

                <Divider />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <Button onClick={hideModal} disabled={loading}>Batal</Button>
                    <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>Lanjutkan</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default ModalExport;
